/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AgentOwnerAssignmentForm,
  AgentOwnerAssignmentForm$Outbound,
  AgentOwnerAssignmentForm$outboundSchema,
} from "../components/agentownerassignmentform.js";

export type ReassignAgentSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ReassignAgentRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  agentOwnerAssignmentForm: AgentOwnerAssignmentForm;
};

/** @internal */
export type ReassignAgentSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ReassignAgentSecurity$outboundSchema: z.ZodMiniType<
  ReassignAgentSecurity$Outbound,
  ReassignAgentSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function reassignAgentSecurityToJSON(
  reassignAgentSecurity: ReassignAgentSecurity,
): string {
  return JSON.stringify(
    ReassignAgentSecurity$outboundSchema.parse(reassignAgentSecurity),
  );
}

/** @internal */
export type ReassignAgentRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  AgentOwnerAssignmentForm: AgentOwnerAssignmentForm$Outbound;
};

/** @internal */
export const ReassignAgentRequest$outboundSchema: z.ZodMiniType<
  ReassignAgentRequest$Outbound,
  ReassignAgentRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    agentOwnerAssignmentForm: AgentOwnerAssignmentForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      agentOwnerAssignmentForm: "AgentOwnerAssignmentForm",
    });
  }),
);

export function reassignAgentRequestToJSON(
  reassignAgentRequest: ReassignAgentRequest,
): string {
  return JSON.stringify(
    ReassignAgentRequest$outboundSchema.parse(reassignAgentRequest),
  );
}
